/** default layout column of Grid Row  */
export const DEFAULT_LAYOUT_COLUMN = 24;

/** max layout column of windowSizeTypes */
export const MAX_LAYOUT_COLUMNS = {
	mobile: 4,
	tablet_small: 8,
	tablet: 8,
	laptop: 12,
	desktop: 12,
} as const;

/**
 * row styles of windowSizeTypes
 * {margin}: margin-left and right (undefined = auto)
 * {width}: fixed width for GridRow (undefined = flex)
 * {gutter}: space beteewn Col
 */
export const GRID_ROW_STYLE = {
	mobile: {
		margin: 11,
		width: undefined,
		gutter: 10,
	},
	tablet_small: {
		margin: 12,
		width: undefined,
		gutter: 16,
	},
	tablet: {
		margin: undefined,
		width: 886,
		gutter: 16,
	},
	laptop: {
		margin: 22,
		width: undefined,
		gutter: 24,
	},
	desktop: {
		margin: undefined,
		width: 1632,
		gutter: 32,
	},
} as const;
